import { render } from "./ProjectsWithRegions.vue?vue&type=template&id=6d019bfb&scoped=true&ts=true"
import script from "./ProjectsWithRegions.vue?vue&type=script&lang=ts"
export * from "./ProjectsWithRegions.vue?vue&type=script&lang=ts"

import "./ProjectsWithRegions.vue?vue&type=style&index=0&id=6d019bfb&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d019bfb"]])

export default __exports__